import { render, staticRenderFns } from "./indexResearch.vue?vue&type=template&id=14a8bfb7"
import script from "./indexResearch.vue?vue&type=script&lang=js"
export * from "./indexResearch.vue?vue&type=script&lang=js"
import style0 from "./indexResearch.vue?vue&type=style&index=0&id=14a8bfb7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports